import { map } from "lodash";

declare const jQuery: any;
const $ = jQuery;

export function timedCalls(func: Function, numCalls: number, wait: number): void
{
	for (let counter = 0; counter < numCalls; ++counter)
	{
		setTimeout(func, wait * counter);
	}
}

export function logObj(...xs): void
{
	console.log.apply(console, map(xs, x => {
		if (typeof x === 'object') return JSON.parse(JSON.stringify(x));
		return x;
	}))
}

export function safeParseJSON(json: string): any
{
	try
	{
		return JSON.parse(json);
	}
	catch (e)
	{
		console.error("Failed to parse JSON string", json, e);
		return undefined;
	}
}

export function ajaxCall(action: string, data: any = null): Promise<any>
{
	return new Promise<any>((resolve, reject) => {
		$.ajax({
			url: '/wp-admin/admin-ajax.php',
			type: 'POST',
			dataType: 'json',
			data: {
				action,
				data: JSON.stringify(data),
			},
			error: function error(x,y,z) {
				console.error("ajaxCall error",x,y,z);
				reject({
					response: x.responseJSON,
					status: x.status,
				});
			},
			success: resolve,
		});
	});
}

export function inArray(array: any[], value: any): boolean
{
	return array.indexOf(value) >= 0;
}

// array is mutated
export function uniquePush(array: any[], value: any): void
{
	if (!inArray(array, value))
	{
		array.push(value);
	}
}

if (!window["iw"])
{
	window["iw"] = {};
}
if (!window["iw"].utils)
{
	window["iw"].utils = {};
}
window["iw"].utils.logObj = logObj;
window["iw"].utils.safeParseJSON = safeParseJSON;
window["iw"].utils.ajaxCall = ajaxCall;
